import getStore from '../store/store';
import RetentionPoliciesListOptionState from '../store/schema/RetentionPoliciesListOptionState';
import { AvailableRetentionPolicyRowType } from '../store/schema/RetentionPolicyRowType';

export default function getAvailablePoliciesListState(): RetentionPoliciesListOptionState<
    AvailableRetentionPolicyRowType
> {
    return getStore().availablePoliciesListState;
}
